class SiteBase {
    constructor() {
        this.header = document.querySelector('#header');
        this.body = document.querySelector('#body');
        this._addmailtoui();
        this._bodyAddPaddingTop();
        this._paginateArrow();
        this._frontHeaderSetting();
        this._floatCtaSetting();


    }
    
    _addmailtoui(){
        // https://pisuke-code.com/chrome-mailto-not-working/
        window.addEventListener('load', function(){
            if(/chrom(e|ium)/.test(window.navigator.userAgent.toLowerCase())){
                const script = document.createElement("script");
                script.type =  'text/javascript';
                script.src =  'https://cdn.jsdelivr.net/npm/mailtoui@1.0.3/dist/mailtoui-min.js';
                document.body.appendChild(script);
            }
        });
    }

    _bodyAddPaddingTop(){

        window.addEventListener('load', (event) => {
            if(window.innerWidth < 980){
                this.body.style.paddingTop = this.header.clientHeight + 'px';
            }
        });

        window.addEventListener('resize', (event) => {
            if(window.innerWidth < 980){
                this.body.style.paddingTop = this.header.clientHeight + 'px';
            } else {
                this.body.style.paddingTop = 0;
            }
        });
    }

    _paginateArrow(){
        /**
         * ページネーションの矢印
         * SiteData.root_urlはfunction.phpでphpから受け取った値
         */
         window.addEventListener('load', () => {
            const prevBtn = document.querySelector('.prev');
            const nextBtn = document.querySelector('.next');
            if(prevBtn){
            prevBtn.innerHTML = `<img src="${SiteData.root_url}/wp-content/themes/rising/build/images/paginate-prev-icon.svg" >`
            }
            if(nextBtn){
            nextBtn.innerHTML = `<img src="${SiteData.root_url}/wp-content/themes/rising/build/images/paginate-next-icon.svg" >`
            }
        });
    }

    _frontHeaderSetting(){
        window.addEventListener('DOMContentLoaded', function(){
            let siteHeader = document.querySelector('#header');
            window.addEventListener('scroll', function(){
                if(window.scrollY >= 50){
                    siteHeader.classList.add('is-scroll')
                }
                if(window.scrollY < 50){
                    siteHeader.classList.remove('is-scroll')
                }
            });
        });
    }

    _floatCtaSetting(){
        /**
         * フロートメニュー操作
         */
        window.addEventListener('DOMContentLoaded', function(){
            let floatCta = document.querySelector('.bl-floatNav')
            if(floatCta){
                window.addEventListener('scroll', function(){
                    let documentHeight = document.documentElement.scrollHeight;
                    let viweHeight = document.documentElement.clientHeight;
                    let scrollHeight = documentHeight - viweHeight;

                    if(window.scrollY >= 50 && window.scrollY <= (scrollHeight - 300)){
                        floatCta.classList.add('is-active')
                    } else{
                        floatCta.classList.remove('is-active')
                    }
                });
            }
        });
    }
}

export default SiteBase;